var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCircularReqIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17874_1878)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.964,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29503 0.485104C10.4876 0.344029 12.9094 1.62528 14.5607 4.32885C15.5421 6.18235 15.7504 8.11985 15.1857 10.1414C14.3575 12.6778 12.6752 14.3601 10.1388 15.1882C7.54056 15.8811 5.19681 15.3916 3.10753 13.7195C1.00469 11.8073 0.166151 9.43751 0.591905 6.6101C1.15563 3.98432 2.66084 2.12494 5.10753 1.03198C5.81625 0.750629 6.54544 0.568338 7.29503 0.485104ZM7.95128 1.4851C10.5166 1.59247 12.4385 2.74872 13.7169 4.95385C14.5793 6.70045 14.6835 8.49214 14.0294 10.3289C13.1479 12.4289 11.601 13.7571 9.38878 14.3132C6.69706 14.7912 4.49394 13.9735 2.77941 11.8601C1.4361 9.93592 1.15485 7.86301 1.93566 5.64135C2.81718 3.54126 4.36406 2.21314 6.57628 1.65698C7.03487 1.56319 7.49322 1.5059 7.95128 1.4851Z",
    fill: "#6A097D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79753 3.9846C8.10566 3.91742 8.32963 4.02157 8.46941 4.2971C8.48503 5.35954 8.49025 6.42204 8.48503 7.4846C9.54759 7.47938 10.6101 7.4846 11.6725 7.50023C11.8909 7.58795 11.995 7.74938 11.985 7.9846C11.995 8.21982 11.8909 8.38126 11.6725 8.46898C10.6101 8.4846 9.54759 8.48982 8.48503 8.4846C8.49025 9.54717 8.48503 10.6097 8.46941 11.6721C8.38169 11.8904 8.22025 11.9946 7.98503 11.9846C7.74981 11.9946 7.58838 11.8904 7.50066 11.6721C7.48503 10.6097 7.47981 9.54717 7.48503 8.4846C6.42247 8.48982 5.35997 8.4846 4.29753 8.46898C4.07919 8.38126 3.97503 8.21982 3.98503 7.9846C3.97503 7.74938 4.07919 7.58795 4.29753 7.50023C5.35997 7.4846 6.42247 7.47938 7.48503 7.4846C7.47981 6.42204 7.48503 5.35954 7.50066 4.2971C7.56384 4.15585 7.66281 4.0517 7.79753 3.9846Z",
    fill: "#6A097D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17874_1878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircularReqIcon);
export default __webpack_public_path__ + "static/media/addCircularReqIcon.d950de50b957cdaa6c363cd089d8f5c1.svg";
export { ForwardRef as ReactComponent };